import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../../../shared/colors";

export const useDrawerListItemStyles = makeStyles(() => ({
    root: {
        padding: "0"
    },
    listItemNavlink: {
        width: "100%",
        display: "inline-flex",
        padding: "16px",
        textDecoration: "none"
    },
    listItemIcon: {
        color: "white !important"
    },
    listItemText: {
        color: colors.primary.contrastText,
        alignSelf: "center"
    }
}));
